<template>
    <div>
        <vue-excel-editor v-model="data" readonly ref="safetyReport" >
            <vue-excel-column field="idNo"   label="Vergi / TC Kimlik No" />
            <vue-excel-column field="name"   label="Ad" />
            <vue-excel-column field="address"  label="Adres" />
            <vue-excel-column field="city" label="İl" />
            <vue-excel-column field="district"    label="İlçe" />
            <vue-excel-column field="camera"  label="Kamera" />
            <vue-excel-column field="alarm"  label="Alarm" />
            <vue-excel-column field="account"  label="Sözleşme No" />
            <vue-excel-column field="date"  label="Bağlantı Tarihi" />
        </vue-excel-editor>
    </div>
</template>

<script>
    export default {
        name: 'ExcelReport',
        props:{
            data: Object
        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Reports/modals/ExcelReport.vue